
import axiosInstance from "./axiosInstance";
import { FetchUserInfoResponse } from "../types/fetchUserInfo";

export const fetchUserInfo = async (email: any): Promise<FetchUserInfoResponse> => {
  const response = await axiosInstance.get<FetchUserInfoResponse>(`/api/user-details/get-info?email=${email}`);
  console.log("here-----------------", response)
  return response.data;
};
